import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('AVG');
